import { http } from '@shared/api';
import type {
  AssignCarrierRequest,
  Carrier,
  LogisticsQuoteEntry,
  LogisticsQuoteRequest,
  ShipmentView,
} from '../model/types';

export const logisticsApi = {
  getShipmentByOrder: (orderId: string) =>
    http.get(`logistics/shipments/${orderId}`).json<ShipmentView>(),

  assignCarrier: (shipmentId: string, body: AssignCarrierRequest) =>
    http.post(`logistics/shipments/${shipmentId}/carrier`, { json: body }).json<ShipmentView>(),

  quote: (body: LogisticsQuoteRequest) =>
    http.post('logistics/quote', { json: body }).json<LogisticsQuoteEntry[]>(),

  // TODO(backend): expose vendor-readable carrier list — see spec Appendix B item 2.
  listCarriers: () =>
    http
      .get('logistics/carriers', { searchParams: { activeOnly: 'true' } })
      .json<Carrier[]>(),
};
